import { isNotDefined } from '#misc/is-not-defined.guard';

import { BaseError } from './types/base.error';

/**
 * Error thrown when a required argument is undefined.
 *
 * @extends BaseError
 *
 * @example
 * ```typescript
 * throw new ArgumentUndefinedError('userId');
 * ```
 *
 * @param parameterName - The name of the parameter that was undefined.
 * @param message - Optional custom error message.
 * @param options - Optional error options.
 */
export class ArgumentUndefinedError extends BaseError {
  constructor(parameterName: string, message?: string, options: ErrorOptions = {}) {
    super(isNotDefined(message) ? `${parameterName}: should be defined` : message, options);

    this.name = 'ArgumentUndefinedError';
  }
}
